import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import DeleteIcon from "@material-ui/icons/Delete";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";
import DirectionsRunIcon from "@material-ui/icons/DirectionsRun";

import {
  CONFIGURACION_TIPOGRAFIA_14,
  FILA_BLANCA,
  FILA_GRIS,
  LISTADO_PAGINACION,
} from "config/general/Configuracion";
import {
  grayColor,
  successColor,
  whiteColor,
} from "assets/jss/material-dashboard-pro-react.jsx";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";

import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Button from "components/CustomButtons/Button.jsx";
import TablePagination from "components/TablePagination/TablePagination.jsx";
import Badge from "components/Badge/Badge.jsx";
import WaitDialog from "conten/components/WaitDialog.jsx";
import EncabezadoGrid from "conten/components/EncabezadoGrid";
import FiltroGeneral from "conten/components/FiltroGeneral";
import CampoBadged from "conten/components/CampoBadged";
import TituloPagina2 from "conten/components/TituloPagina2";

import {
  listarPromotorZona,
  guardarPromotorZona,
} from "conten/promotorZonas/PromotorZonaActions";
import { Edit } from "@material-ui/icons";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";

const columnasOrdenar = [
  { campos: [{ id: "", isSorted: false, label: "" }], xs: 12, sm: 12, md: 1, lg: 1 },
  { campos: [{ id: "nombre1", isSorted: true, label: "Promotor" }], xs: 12, sm: 12, md: 2, lg: 2 },
  { campos: [{ id: "z.nombre", isSorted: true, label: "Zona" }], xs: 12, sm: 12, md: 2, lg: 2 },
  { campos: [{ id: "", isSorted: false, label: "Día" }], xs: 12, sm: 12, md: 5, lg: 5 },
  {
    campos: [
      { id: "c.activo", isSorted: true, label: "Estado" },
      { id: "detalle", isSorted: true, label: "Info" },
    ],
    xs: 12,
    sm: 12,
    md: 2,
    lg: 2,
  },

];

const PromotorZonaListar = ({ classes, promotorZonaState, listarPromotorZona, guardarPromotorZona, history }) => {
  const [promotorZonaEditar, setPromotorZonaEditar] = useState(undefined);
  const [filtroLocal, setFiltroLocal] = useState("");
  const [paginacion, setPaginacion] = useState({
    limite: LISTADO_PAGINACION[0],
    actual: 1,
    filtro: '',
    orden: "zona",
    sentido: "ASC",
  });

  useEffect(() => {
    const filtros = {
      ...paginacion,
      ...paginacion.filtro, // promotor, zona, estado incluidos aquí
    };
    listarPromotorZona(filtros);
  }, [paginacion]);



  useEffect(() => {
    if (promotorZonaState.paginacion?.total !== undefined) {
      setPaginacion(prev => ({
        ...prev,
        total: promotorZonaState.paginacion.total
      }));
    }
  }, [promotorZonaState.paginacion?.total]);


  const cambioPagina = (page) => {
    setPaginacion((prev) => ({ ...prev, actual: page }));
  };

  const cambioLimite = (limite) => {
    setPaginacion((prev) => ({ ...prev, limite, actual: 1 }));
  };

  const cambioFiltro = (filtro) => {
    setPaginacion((prev) => ({ ...prev, filtro, actual: 1 }));
  };

  const ordenar = (event, property) => {
    const sentido = paginacion.sentido !== "DESC" ? "DESC" : "ASC";
    setPaginacion((prev) => ({ ...prev, orden: property, sentido, actual: 1 }));
  };

  const { promotorZonas, isActivityIndicatorShown } = promotorZonaState;

  const datosPromotorZonaParaServidor = (pz) => ({
    id: pz.c_id,
    promotor: pz.promotor,
    zona: pz.zona,
    lunes: pz.lunes,
    martes: pz.martes,
    miercoles: pz.miercoles,
    jueves: pz.jueves,
    viernes: pz.viernes,
    sabado: pz.sabado,
    domingo: pz.domingo,
    detalle: pz.detalle,
    activo: pz.c_activo,
  });

  const resultadoBorrar = () => listarPromotorZona(paginacion);

  const borrarPromotorZona = (pz) => {
    const actualizado = datosPromotorZonaParaServidor(pz);
    actualizado.activo = false;
    guardarPromotorZona(actualizado, resultadoBorrar);
  };

  const activarPromotorZona = (pz) => {
    const actualizado = datosPromotorZonaParaServidor(pz);
    actualizado.activo = true;
    guardarPromotorZona(actualizado, resultadoBorrar);
  };

  const editarPromotorZona = (promotorZonaEditar) => {
    setPromotorZonaEditar(promotorZonaEditar);
  };

  if (promotorZonaEditar !== undefined) {
    return (
      <Redirect
        push
        to={{
          pathname: "../admin/administrar-promotor-zona",
          search: "?editar=true",
          state: { promotorZona: datosPromotorZonaParaServidor(promotorZonaEditar) },
        }}
      />
    );
  }

  return (
    <GridItem xs={12}>
      {isActivityIndicatorShown && <WaitDialog text="Un momento mientras completamos su solicitud" />}
      <Card>
        <CardHeader icon>
          <CardIcon
            color="primary"
            onClick={() => history.push("../admin/administrar-promotor-zona")}
            style={{ cursor: "pointer" }}
          >
            <b>+ Promotor-Zona</b>
            <DirectionsRunIcon />
          </CardIcon>
          <TituloPagina2 texto="Listado de usuarios" color="primary" classes={classes} />
        </CardHeader>

        <CardBody>
          <EncabezadoGrid
            contenidoColumnas={columnasOrdenar}
            eventoOrdenar={ordenar}
            ordenarPor={paginacion.orden}
            sentidoOrden={paginacion.sentido}
            colorFondo={successColor[0]}
            colorTexto={whiteColor}
            tamaLetra={"14px"}
          />
          <FiltroGeneral
            keyFiltro={"FiltroZonas"}
            colorTexto={whiteColor}
            colorFondo={grayColor[21]}
            eventoFiltrar={cambioFiltro}
            tamaLetra={"14px"}
            texto={"Buscar"}
            state={{ state: { filtroLocal }, setState: ({ filtroLocal }) => setFiltroLocal(filtroLocal) }}
          />

          {promotorZonas.map((pz, index) => (
            <GridContainer
              key={index}
              style={{
                ...CONFIGURACION_TIPOGRAFIA_14,
                backgroundColor: index % 2 === 0 ? FILA_BLANCA : FILA_GRIS,
              }}
            >
              <GridItem xs={12} sm={12} md={1} lg={1}>
                {
                  <div>
                    <Button
                      color={pz.c_activo ? "green" : "danger"}
                      simple
                      className={classes.actionButton}
                      key={"edit_" + pz.id}
                      onClick={() => {
                        editarPromotorZona(pz);
                      }}
                    >
                      <Edit />
                    </Button>
                    {pz.c_activo && (
                      <Button
                        color="green"
                        simple
                        className={classes.actionButton}
                        key={"close_" + pz.id}
                        onClick={(e) =>
                          borrarPromotorZona(pz)
                        }
                      >
                        <DeleteIcon />
                      </Button>
                    )}
                    {!pz.c_activo && (
                      <Button
                        color="danger"
                        simple
                        className={classes.actionButton}
                        key={"close_" + pz.id}
                        onClick={(e) =>
                          activarPromotorZona(pz)
                        }
                      >
                        <RestoreFromTrashIcon />
                      </Button>
                    )}
                  </div>
                }
              </GridItem>
              <GridItem xs={12} sm={12} md={2} lg={2}>{`${pz.nombre1} ${pz.nombre2} ${pz.apellido1} ${pz.apellido2}`}</GridItem>
              <GridItem xs={12} sm={12} md={2} lg={2}>{pz.z_nombre}</GridItem>
              <GridItem xs={12} sm={12} md={5} lg={5}>
                {["lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"].map((dia) => (
                  <CampoBadged key={dia} mostrar={pz[dia]} color="primary" ancho="90px" texto={dia.charAt(0).toUpperCase() + dia.slice(1)} />
                ))}
              </GridItem>
              <GridItem xs={12} sm={12} md={2} lg={2}>
                <div>
                  <Badge color={pz.c_activo ? "greenColor" : "danger"}>
                    {pz.c_activo ? "Activa" : "Borrada"}
                  </Badge>
                </div>
                <div>{pz.detalle.substring(0, 200)}...</div>
              </GridItem>
            </GridContainer>
          ))}

          {paginacion?.total > 0 && (
            <TablePagination
              color="success"
              rowsPerPageOptions={LISTADO_PAGINACION}
              pages={Math.ceil(paginacion.total / paginacion.limite)}
              rowsPerPage={paginacion.limite}
              page={paginacion.actual}
              onChangePage={cambioPagina}
              onChangeRowsPerPage={cambioLimite}
            />
          )}
        </CardBody>
      </Card>
    </GridItem>
  );
};

const mapStateToProps = (state) => ({
  promotorZonaState: state.promotorZonaState,
});

const mapDispatchToProps = (dispatch) => ({
  listarPromotorZona: (paginacion) => dispatch(listarPromotorZona(paginacion, () => { })),
  guardarPromotorZona: (promotorZona, onSuccess) => dispatch(guardarPromotorZona(promotorZona, onSuccess)),
});

export default withStyles(extendedTablesStyle)(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(PromotorZonaListar))
);
